const Actions = self => ({
  setDisplayPopupByUserAction(value) {
    self.displayPopupByUserAction = value;
  },

  setDisplayPopupByCTA(value) {
    self.displayPopupByCTA = value;
  },

  setShowFailLimitReason(value) {
    self.showFailLimitReason = value;
  },
});

export default Actions;
